<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12rVOrx/tc-custom/9781497600621.jpg?1708749528592" alt="This image is the cover for the book Outlaw of Gor, Gorean Saga"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Outlaw of Gor, Gorean Saga
      </h1>
      <p class="bookDescription body article font2">
        <b>A warrior falls as the cult classic sword and sorcery series continues—the inspiration for the film starring Jack Palance.</b><br/><br/>  Tarl Cabot finds himself transported back to Counter-Earth from the sedate life he has known as a history professor on Earth. He is glad to be back in his role as a dominant warrior and again in the arms of his true love. Yet Tarl finds that his name on Gor has been tainted, his city defiled, and all those he loves made outcasts. He is no longer in the position of a proud warrior, but an outlaw for whom the simplest answers must come at a high price. He wonders why the Priest-Kings have called him back to Gor, and whether it is only to render him powerless.<br/>  <br/> Rediscover this brilliantly imagined world where men are masters and women live to serve their every desire.<br/>  <br/><i>Outlaw of Gor </i>is the 2nd book in the Gorean Saga, but you may enjoy reading the series in any order. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Norman
      </h2>
      
      <p class="authorDescription body article">John Norman is the creator of the Gorean Saga, the longest-running series of adventure novels in science fiction history. He is also the author of the science fiction series the Telnarian Histories, as well as <I>Ghost Dance</I>, <I>Time Slave</I>, <I>The Totems of Abydos</I>, <I>Imaginative Sex</I>, and <I>Norman Invasions</I>. Norman is married and has three children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?79037566